import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React from 'react';
import Slider from 'react-slick';

import { useCurrencyRates } from '@/api/forex';
import { liveExchangeRatesSettings } from '@/utils/constants/carousel/LiveExchangeRateSlider';

import CurrencyIcon from '../components/reusables/CurrencyIcon';

const LiveExchangeRates = () => {
  const { currencies: currencyOptions } = useCurrencyRates();
  return (
    <section className="bg bg--light bg-rates">
      <div className="home__customer">
        <div className="container">
          <h2 className="section__title-small heading-h2 text-center">
            <span className="heading-bold">Live Exchange Rates</span>
          </h2>
        </div>
        <div className="home__customer--slider slider--new">
          <Slider {...liveExchangeRatesSettings}>
            {currencyOptions.map((rates, index) => (
              <div className="item forex-item" key={index}>
                <div className="slide-content slide-card">
                  <div className="slide-top">
                    <CurrencyIcon
                      currencyCode={rates.currencyCode}
                      isFullFormRequired={true}
                      className="fx-black-color text--country"
                    />
                    {/* <p className="fx-black-color text--country">
                      {CurrencyAbbrevations[rates.currencyCode]}
                    </p> */}
                  </div>
                  <div className="currency-card">
                    <div className="user">
                      <p className="text--country fx-black-color">Buy</p>
                      <div className="right">
                        <p className="text--black text--bold name">
                          ₹
                          {rates.customerBuyRate.toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="user">
                      <p className="text--country fx-black-color">Sell</p>
                      <div className="right">
                        <p className="text--black text--bold name">
                          ₹
                          {rates.customerSellRate.toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                          })}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default LiveExchangeRates;
